'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppFeature = exports.SubProp = exports.Prop = exports.AppFeatures = void 0;
const lodash_1 = require("lodash");
class AppFeatures extends Array {
    static findFeatureProp(props, name) {
        const feature = props.find(feature => {
            return feature.name === name;
        });
        return feature || null;
    }
    static mergeProps(props, newProps) {
        newProps.forEach(newProp => {
            if (newProp === null || newProp === void 0 ? void 0 : newProp.name) {
                const prop = AppFeatures.findFeatureProp(props, newProp.name);
                if ((0, lodash_1.isEmpty)(prop)) {
                    props.push(newProp);
                }
            }
        });
        return props.map(prop => {
            const newProp = AppFeatures.findFeatureProp(newProps, prop.name);
            if (!(0, lodash_1.isEmpty)(newProp)) {
                newProp.value = (0, lodash_1.merge)({}, prop.value, newProp.value);
                return newProp;
            }
            return prop;
        });
    }
    findFeature(name, category) {
        const feature = this.find(feature => {
            if (!category)
                return feature.name === name;
            return feature.name === name && feature.category === category;
        });
        return feature || new AppFeature({ name, category });
    }
    mergeFeatures(newFeatures) {
        newFeatures.forEach(newFeature => {
            if (newFeature === null || newFeature === void 0 ? void 0 : newFeature.name) {
                const existingFeature = this.find(feature => {
                    if (!newFeature.category)
                        return feature.name === newFeature.name;
                    return (feature.name === newFeature.name &&
                        feature.category === newFeature.category);
                });
                if ((0, lodash_1.isEmpty)(existingFeature)) {
                    this.push(newFeature);
                }
            }
        });
        this.forEach((appFeature, index) => {
            const newFeature = newFeatures.find(newFeature => newFeature.name === appFeature.name);
            if (!(0, lodash_1.isEmpty)(newFeature)) {
                if (newFeature === null || newFeature === void 0 ? void 0 : newFeature.props.length) {
                    newFeature.props = AppFeatures.mergeProps(appFeature.props, newFeature.props);
                }
                else {
                    newFeature.props = appFeature.props;
                }
                newFeature.value = (0, lodash_1.merge)({}, appFeature.value, newFeature.value);
                this[index] = newFeature;
            }
        });
        return this;
    }
}
exports.AppFeatures = AppFeatures;
class Prop {
    constructor({ id, name, value, enabled }) {
        this.id = id;
        this.name = name;
        this.value = value;
        this.enabled = enabled;
    }
    /**
     * Check if feature is enabled
     * @param defaultValue - Fallback value
     */
    isEnabled(defaultValue) {
        if (this.enabled != undefined) {
            return this.enabled;
        }
        if (defaultValue != undefined) {
            return defaultValue;
        }
        return false;
    }
    /**
     * Get feature value
     * @param defaultValue - Fallback value
     */
    getValue(defaultValue) {
        if (this.value != undefined) {
            return this.value;
        }
        if (defaultValue != undefined) {
            return defaultValue;
        }
        return null;
    }
}
exports.Prop = Prop;
class SubProp extends Prop {
    constructor({ id, name, value, enabled, props }) {
        super({ id, name, value, enabled });
        this.props = (props || []).map(prop => {
            return new SubProp(prop);
        });
    }
    /**
     * Get prop by name
     * @param name - Prop name
     */
    getProps(name) {
        const prop = (this.props || []).find(subprop => {
            return subprop.name === name;
        });
        return new SubProp(prop || { name: name });
    }
}
exports.SubProp = SubProp;
class AppFeature extends SubProp {
    constructor(appFeature = {}) {
        super(appFeature);
        this.category = appFeature.category;
    }
}
exports.AppFeature = AppFeature;
//# sourceMappingURL=app-feature.model.js.map